import { render } from "./AttachmentPreviewComponent.vue?vue&type=template&id=aba62e7c&scoped=true"
import script from "./AttachmentPreviewComponent.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewComponent.vue?vue&type=script&lang=js"

import "./AttachmentPreviewComponent.vue?vue&type=style&index=0&id=aba62e7c&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba62e7c"]])

export default __exports__